import React from 'react';

import {Container, ButtonBackStyle} from './styles'

type Props = {
    label: string,
    disabled?: boolean,
} & React.ComponentPropsWithoutRef<'button'>;

const ButtonBack = ({...props}: Props, ref: React.Ref<HTMLButtonElement>) => {
    return (
        <div>
            <Container>
                <ButtonBackStyle {...props} disabled={props.disabled}>
                    {props.label}</ButtonBackStyle>
            </Container>
        </div>
    );
};

ButtonBack.defaultProps = {
    label: 'OK',
    loading: 'false',
}

export default ButtonBack;
